module.exports = __webpack_public_path__ + "static/media/1-wap.7941b4c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/1-wap.png
// module id = 579
// module chunks = 0